import React from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'
import { Box, Tile, H1, Button, P } from '@allied-solutions/affinity'
import { Plus } from '@allied-solutions/affinity-react-icons/standard'

const StyledTile = styled(Tile)`
  border-radius: ${props => props.theme.radii[6]};
`

export const DashboardTileEmpty = () => {
  return (
    <StyledTile p="7xl">
      <Box
        display="flex"
        alignItems="center"
        flexDirection={['column', 'row']}
        flexWrap={['wrap', 'nowrap']}
      >
        <img src="/empty-state-illustration.svg" alt="No insurance found" />
        <Box>
          <P typeStyle="labelMedium.medium" color="text.secondary" mb="1">
            Oh shoot...
          </P>
          <H1 typeStyle="titleMedium.bold" mb="1">
            You have not linked a Reference ID!
          </H1>
          <P typeStyle="labelLarge.regular" color="text.secondary" mb="0">
            Add a new or existing insurance policy by adding your reference ID
            to this account.
          </P>
          <Button
            icon={Plus}
            outlined
            variant="brand"
            size="lg"
            mt="5xl"
            onClick={() => {
              navigate('/enter-reference-id/')
            }}
          >
            Add Reference ID
          </Button>
        </Box>
      </Box>
    </StyledTile>
  )
}
